import React from 'react';

const BulkCapture = props => {
    return (
        <div>Bulk Resource Capture</div>
    );
};

export default BulkCapture;
